import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@/locales/en.json";
import zh from "@/locales/zh.json";
import tr from "@/locales/tr.json";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "zh", label: "简体中文" },
  { code: "tr", label: "Türkçe" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      tr: { translation: tr },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "zh", "tr"],
    // Map zh-CN, zh-Hans, zh-TW, etc. to the "zh" bundle.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      // Remember an explicit choice, then fall back to the browser language.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "mariabackup_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
